var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26 12.667v-5.977c0-0.442-0.176-0.866-0.488-1.179l-2.357-2.357c-0.313-0.313-0.736-0.488-1.179-0.488h-14.309c-0.92 0-1.667 0.746-1.667 1.667v8.333c-1.841 0-3.333 1.492-3.333 3.333v5.833c0 0.46 0.373 0.833 0.833 0.833h2.5v5c0 0.92 0.746 1.667 1.667 1.667h16.667c0.92 0 1.667-0.746 1.667-1.667v-5h2.5c0.46 0 0.833-0.373 0.833-0.833v-5.833c0-1.841-1.492-3.333-3.333-3.333zM22.667 26h-13.333v-5h13.333v5zM22.667 14.333h-13.333v-8.333h10v2.5c0 0.46 0.373 0.833 0.833 0.833h2.5v5zM25.167 18.083c-0.69 0-1.25-0.56-1.25-1.25s0.56-1.25 1.25-1.25 1.25 0.559 1.25 1.25c0 0.69-0.56 1.25-1.25 1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterDeprecated);
export default __webpack_public_path__ + "static/media/printer_deprecated.458dde401462faff64ba8b5acd62697a.svg";
export { ForwardRef as ReactComponent };